import React, { useState } from "react";
import "./styles/Navbar.css";
import Logo from "../images/logo.png";
import Spin from "react-reveal/Spin";

import { Link } from "react-router-dom";
import NavButton from "./ui/NavButton";
const Navbar = () => {
  const [state, setState] = useState({
    showMenu: false,
    clase: "",
  });

  let claseB = false ? "nav-burger_button" : "nav-burger_button";

  const showMenuF = () => {
    if (state.showMenu) {
      setState({
        clase: "",
        showMenu: false,
      });
    } else {
      setState({
        clase: "show-menu",
        showMenu: true,
      });
    }
  };
  const closeMenu = () => {
    setState({
      clase: "",
      showMenu: false,
    });
  };

  return (
    <>
      <div className="c-navbar">
        <Link to="/">
          <Spin>
            <img className="nav-logo" src={Logo} alt="" />
          </Spin>
        </Link>
        <button
          type="button"
          className={`nav-burger_button ${claseB}`}
          onClick={showMenuF}
        >
          <i className="fa fa-bars" aria-hidden="true"></i>
        </button>
        <div className={`nav-buttons_desktop ${state.clase} `}>
          <NavButton url={"/about"} label={"Sobre Mi"} fn={closeMenu} />
          <NavButton url={"/works"} label={"Trabajos"} fn={closeMenu} />
          <NavButton url={"/blog"} label={"Blog"} fn={closeMenu} />
          <NavButton url={"/contact"} label={"Contacto"} fn={closeMenu} />
        </div>
      </div>
    </>
  );
};

export default Navbar;
